var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"authentication"},[_c('router-view'),_c('c-snackbar'),_c('loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }